<template>
  <v-autocomplete
    :value="value"
    :items="getPriceLists"
    :label="label"
    outlined
    clearable
    item-text="name"
    item-value="id"
    :loading="loading || listLoading"
    :disabled="loading || disabled || listLoading"
    @input="emitInput"
  >
  </v-autocomplete>
</template>

  <script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'PriceListSelectField',
    props: {
      label: {
        type: String,
        default: 'Прайс-лист',
      },
      value: {
        type: Number,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        listLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        getPriceLists: 'priceList/getPriceLists',
      }),
    },
    created () {
      this.listLoading = true
      this.$store.dispatch('priceList/fetchPriceLists', {
        limit: 100000,
        offset: 0,
        page: 1,
      }).finally(() => { this.listLoading = false })
    },
    methods: {
      emitInput (value) {
        if (value === undefined) {
          value = null
        }
        this.$emit('input', value)
      },
    },
  }
  </script>
